module.exports = __webpack_public_path__ + "static/media/logoMobile.1999189d.svg";